import { generateBaseQueryKeysList } from '@/queries/utils';

export const CASE_KEYS = {
  main: 'cases',
  archive: 'archive',
  reallocationCandidates: 'reallocationCandidates',
  reviewsData: 'reviews',
  resourcesData: 'resources',
  logs: 'logs',
  activityLogs: 'activity-logs',
  duplicates: 'duplicate',
  bulkAssignmentList: 'bulkAssignmentList',
  bulkAssignmentStatus: 'bulk-assignment-status',
  accessTickets: 'access-tickets',
};

export const caseQueryKeys = {
  ...generateBaseQueryKeysList(CASE_KEYS.main),
  // List-related
  getCounts: (...args: unknown[]) => [CASE_KEYS.main, 'counts', ...args] as const,
  getArchive: (...args: unknown[]) => [CASE_KEYS.main, CASE_KEYS.archive, ...args] as const,
  getReallocationCandidates: (...args: unknown[]) => [CASE_KEYS.reallocationCandidates, ...args] as const,
  getBulkAssignmentCases: (...args: unknown[]) => [CASE_KEYS.bulkAssignmentList, ...args] as const,
  getBulkAssignmentStatus: () => [CASE_KEYS.bulkAssignmentStatus] as const,
  getDuplicates: (...args: unknown[]) => [CASE_KEYS.main, CASE_KEYS.duplicates, ...args] as const,
  // Item-related
  getCaseReviewsData: (caseId?: string, ...args: unknown[]) =>
    [...caseQueryKeys.getItem(caseId), CASE_KEYS.reviewsData, ...args] as const,
  getCaseResourcesData: (caseId?: string, ...args: unknown[]) =>
    [...caseQueryKeys.getItem(caseId), CASE_KEYS.resourcesData, ...args] as const,
  getLogs: (caseId?: string, withQueryTotals?: boolean, ...args: unknown[]) =>
    [...caseQueryKeys.getItem(caseId), CASE_KEYS.logs, withQueryTotals ? 'totals' : '', ...args] as const,
  getActivityLogs: (caseId?: string, ...args: unknown[]) =>
    [...caseQueryKeys.getItem(caseId), CASE_KEYS.activityLogs, ...args] as const,
  getAccessTickets: (caseId?: string, ...args: unknown[]) =>
    [...caseQueryKeys.getItem(caseId), CASE_KEYS.accessTickets, ...args] as const,
};
